/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pastevents1Inputs */

const en_pastevents1 = /** @type {(inputs: Pastevents1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past Events`)
};

const de_pastevents1 = /** @type {(inputs: Pastevents1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergangene Events`)
};

/**
* | output |
* | --- |
* | "Past Events" |
*
* @param {Pastevents1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pastevents1 = /** @type {((inputs?: Pastevents1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pastevents1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pastevents1(inputs)
	return de_pastevents1(inputs)
});
export { pastevents1 as "pastEvents" }